/**
 * @generated SignedSource<<5a8e9ee347df55716cea3a24a164e01c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ApiKeySectionAdminDisableApiKeyMutation$variables = {
  id: string;
};
export type ApiKeySectionAdminDisableApiKeyMutation$data = {
  readonly adminDisableApiKey: {
    readonly disabledApiKeyId: string;
  } | null;
};
export type ApiKeySectionAdminDisableApiKeyMutation = {
  response: ApiKeySectionAdminDisableApiKeyMutation$data;
  variables: ApiKeySectionAdminDisableApiKeyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "AdminDisableApiKey",
    "kind": "LinkedField",
    "name": "adminDisableApiKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "disabledApiKeyId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ApiKeySectionAdminDisableApiKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ApiKeySectionAdminDisableApiKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e79abe1be8610c41a75eb3dd81389af3",
    "id": null,
    "metadata": {},
    "name": "ApiKeySectionAdminDisableApiKeyMutation",
    "operationKind": "mutation",
    "text": "mutation ApiKeySectionAdminDisableApiKeyMutation(\n  $id: ID!\n) {\n  adminDisableApiKey(id: $id) {\n    disabledApiKeyId\n  }\n}\n"
  }
};
})();

(node as any).hash = "27bada214ea7652770c46b2cf672f171";

export default node;
